import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { timeZoneSelector } from 'Features/App/appSlice';
import { useGetVocStatusesByFilterQuery } from 'Services/api/vocStatusesApi';
import { useUrlParams } from 'Utils/useUrlParams';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { filterStatus, initialParamsState } from 'Features/Stations/Station/Messages/messageUtils';
import { MessagesIncoming as StationDatasourceMessagesIncoming }
  from 'Features/Stations/Station/Datasource/Messages/Station.Datasource.Messages.Incoming';
import { useGetMessageByIdQuery, useLazyGetMessageIncomingQuery, useLazyGetMessagesQuery } from 'Services/api/messageApi';
import StationMessagesCut from 'Features/Stations/Station/Messages/Station.Messages.Cut';

export const EventsErrorsMessages = () => {
  const selectedZone = useSelector(timeZoneSelector);
  const useGetStatusQuery = () => useGetVocStatusesByFilterQuery({
    'entity-types': ['COMMON', 'MESSAGE'],
    'status-types': ['WARNING', 'ERROR'],
  });
  const { data: statuses = [], isFetching: isLoadingStatuses } = useGetStatusQuery();

  const [urlParams] = useUrlParams({
    status: 'number-array',
    programs: 'number-array',
    formats: 'number-array',
    channels: 'number-array',
    page: 'number',
    station: 'number',
    datasource: 'number',
  });

  const filteredStatuses = React.useMemo(() => {
    const tmp = filterStatus(urlParams.status, isLoadingStatuses, statuses);
    if (tmp.length > 0) return tmp;
    return statuses.map((status) => status.id);
  }, [isLoadingStatuses, statuses, urlParams.status]);

  const defaultParam = {
    date: {
      startDate: (urlParams.startDate || initialParamsState.startDate),
      endDate: (urlParams.endDate || initialParamsState.endDate),
    },
    size: urlParams.size || initialParamsState.size,
    page: urlParams.page || initialParamsState.page,
    status: filteredStatuses,
    programs: urlParams.programs || initialParamsState.programs,
    formats: urlParams.formats || initialParamsState.formats,
    channels: initialParamsState.channels(urlParams.channels),
    isBadMessages: true,
    timeZone: selectedZone.selectedUserTimeZone,
    station: urlParams.station || initialParamsState.station,
    datasource: urlParams.datasource || initialParamsState.datasource,
  };

  const headersMessagesCut = React.useMemo(() => [
    { name: `Срок UTC${defaultParam.timeZone}`, cellProps: { flex: '1 0' } },
    { name: `Время создания UTC${defaultParam.timeZone}`, cellProps: { flex: '1 0' } },
    { name: 'Формат', cellProps: { flex: '0 1 10%' } },
    { name: 'Программа', cellProps: { flex: '1 0' } },
    { name: 'Статус', cellProps: { flex: '1 0' } },
    { name: 'Источник', cellProps: { flex: '1 0' } },
  ], [defaultParam.timeZone]);

  if (isLoadingStatuses) return <SuspenseSpinner />;
  return (
    <Routes>
      <Route index element={<Navigate to="cut" replace />} />

      <Route
        path="meteomessages"
        element={(
          <StationDatasourceMessagesIncoming
            hasRepeatSend
            params={defaultParam}
            useGetStatusQuery={useGetStatusQuery}
            timeZone="settings"
            useGetMessagesIncomingQuery={useLazyGetMessageIncomingQuery}
          />
        )}
      />

      <Route
        path="cut"
        element={(
          <StationMessagesCut
            params={defaultParam}
            useGetMessages={useLazyGetMessagesQuery}
            useGetMessageFileQuery={useGetMessageByIdQuery}
            useGetStatusQuery={useGetStatusQuery}
            timeZone="settings"
            isArchive
            headersMessagesCut={headersMessagesCut}
          />
        )}
      />

      <Route path="*" element={<Navigate to="cut" replace />} />
    </Routes>
  );
};
